// Un groupe, plusieurs équipes engagées (D-042) : l'effectif et les entraînements
// sont communs ; un match ne convoque que les joueuses de son équipe engagée.

/** Une joueuse est-elle concernée par un match de cette équipe engagée ? (aucune = toutes ; match sans équipe = tout le groupe) */
export const inSquad = (memberSquads: readonly string[] | null | undefined, squadId: string | null | undefined): boolean =>
  !squadId || !memberSquads?.length || memberSquads.includes(squadId);

/** Cocher / décocher une équipe d'une joueuse ; toutes cochées (ou aucune) = toutes, rangé vide. */
export function toggleSquad(current: readonly string[], id: string, all: readonly string[]): string[] {
  const now = current.length ? [...current] : [...all];
  const next = now.includes(id) ? now.filter(x => x !== id) : [...now, id];
  if (!next.length || all.every(x => next.includes(x))) return [];
  return all.filter(x => next.includes(x));
}

/** Les joueuses présentes dans les deux équipes engagées (conflit le même jour). */
export const inBoth = <T extends { squad_ids?: readonly string[] | null }>(roster: T[], a: string, b: string) =>
  roster.filter(r => inSquad(r.squad_ids, a) && inSquad(r.squad_ids, b));
